/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.12.11",
    versionName: "0.2.0-nightly.2025.12.11",
    versionChannel: "nightly",
    buildDate: "2025-12-11T00:08:11.238Z",
    commitHash: "3939f9b97893fb2586472ba906c59964cff36174",
};
